var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 1114.219,
    height: 1455.39,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_8",
    x1: 989.64,
    y1: 200.81,
    x2: 316.4,
    y2: 1366.89,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46b6b5",
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f92c4",
    id: "stop6"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-2{font-size:765.35px;fill:#46b6b5;font-family:Calibri}"))), /*#__PURE__*/React.createElement("path", {
    d: "m351.309 474.78-138.51-138.51a642.23 642.23 0 0 1 188.48-117.88 433.31 433.31 0 0 0 185.34-143.9L641.829 0l55.17 74.47a433.28 433.28 0 0 0 185.33 143.9c63.37 25.63 133.16 65.75 189.46 111.13a533.68 533.68 0 0 1 42.4 37.85 866.59 866.59 0 0 1-118.55 38.3c-58 14-124.42 22.1-167.2 2.43-154.98-71.26-342.44-49.02-477.13 66.7zm-43.51 42.82-138.42-138.42a641.7 641.7 0 0 0-7.61 860.35l138.5-138.53c-142.15-168.55-139.64-417.67 7.53-583.4zm686.6 686.6c-47-12.49-101.49-16.06-151 7.82-162.54 78.44-361.29 58.91-500.74-67.09l-138.25 138.28c114.59 106.79 268.41 172.17 437.42 172.18 160.74 0 322.94-66.35 438.39-165.37q17.74-15.23 34-31.44s-52.22-36.41-119.82-54.38z",
    id: "path11",
    style: {
      fill: "url(#New_Gradient_Swatch_8)",
      fillRule: "evenodd"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCOnly);
export default __webpack_public_path__ + "static/media/cOnly.57c3a25aa693e492883acbd9bef2d9fe.svg";
export { ForwardRef as ReactComponent };